module.exports = __webpack_public_path__ + "static/media/bank.3b2ce0cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/payment-verification/bank.png
// module id = 1692
// module chunks = 0